var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fdc-panel',{attrs:{"title":"실시간 이상 검출 건수"}},[_c('div',{staticClass:"status_area"},[_c('brique-chart',{staticStyle:{"height":"100%","width":"95%","margin":"auto"},attrs:{"id":"liveFaultDetectionStatusChart"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }